/*
 * @Author: Ashley.Liu
 * @Date: 2022-06-12 16:15:23
 * @LastEditTime: 2022-06-21 14:10:37
 * @Description: desc
 */
import Menu from './menu/index'
import '../assets/fonts/iconfont.css'
const components = [Menu]

function install(Vue) {
  components.forEach((comp) => {
    Vue.use(comp)
  })
}

if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue)
}

export default { install, Menu }
